import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { SpecificSearchToneProcessorFactory } from '../../../../core/processorfactory/specificsearchtoneprocessorfactory';
import { SpecificSearchToneDtoImpl } from '../../../../core/dto/specificsearchtone/specificsearchtonedto';
import { SpecificSearchToneResponse } from '../../../../core/api/search/specificsearchtone/specificsearchtoneresponse';
import { SpecificSearchToneRequestImpl } from '../../../../core/api/search/specificsearchtone/specificsearchtonerequest';
import { SearchToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/searchtone/searchtonedto';
import { SearchToneResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtoneresponse';
import { SearchToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtonerequest';
import { SearchToneBasedOnCodeResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtonebasedoncode/searchtonebasedoncoderesponse';
import { TextTransform } from '../../../toolkit/texttransform/texttransform';
// import { SearchToneBasedOnCodeResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtonebasedoncode/searchtonebasedoncoderesponse';

export interface SearchListAPIModel extends APIModel
{
    loadMore(startIndex: number, offset: number, searchKey: string): void;
    getSearchToneBasedOnId(startIndex: number, offset: number, searchKey: string): void;
    getArtistSearchTone(startIndex: number, offset: number, searchKey: string): void;
}

export class SearchListAPIModelImpl extends APIModelImpl implements SearchListAPIModel
{
    private searchProcessor: SpecificSearchToneProcessorFactory;

    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.searchProcessor = this.getAPIProcesssorFactory().getSpecificSearchToneProcessorFactory();
    }

    getArtistSearchTone(startIndex: number, offset: number, searchKey: string)
    {
            let searchToneDto = new SearchToneDtoImpl();
            searchToneDto.setPagePerCount(offset);
            searchToneDto.setLanguage(TextTransform.checkSearchedLanguage(searchKey,
                this.getContext().getUserContext().getLanguage()));
            //searchToneDto.setSearchKey("Recently+Added"); 
            searchToneDto.setArtistKey(searchKey);
            searchToneDto.setSearchKey(""); 
            searchToneDto.setCategoryId(0);
            searchToneDto.setSortBy("Order_By");
            searchToneDto.setAlignBy("ASC");
            searchToneDto.setPageNo(startIndex);
            searchToneDto.setSearchLanguage(TextTransform.checkSearchedLanguage(searchKey,
                this.getContext().getUserContext().getLanguage()));
    
            this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
            .getSearchTone()
            .success((searchToneResponse: SearchToneResponse)=>
            {
                this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
                searchToneResponse.getDescription(), searchToneResponse.getListOfSearchToneDtos().getListOfTones());
    
             })
            .failure((searchToneResponse : SearchToneResponse)=>
             {
               this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
               searchToneResponse.getDescription(), undefined);
             })
            .execute(new SearchToneRequestImpl(searchToneDto));
    }

    getSearchToneBasedOnId(startIndex: number, offset: number, searchKey: string): void
    {
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(0);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        searchToneDto.setToneId(searchKey); 
        searchToneDto.setCategoryId(0);
        searchToneDto.setPageNo(startIndex);
        searchToneDto.setPagePerCount(offset);

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getToneBasedOnCode()
        .success((searchToneResponse: SearchToneBasedOnCodeResponse)=>
        {
            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), searchToneResponse.getSearchToneDto());

         })
        .failure((searchToneResponse : SearchToneBasedOnCodeResponse)=>
         {
             console.log("--------searchbasedoncode: " + searchToneResponse.getDescription());
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), undefined);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    loadMore(startIndex: number, offset: number, searchKey: string): void
    {
        let specificSearchToneDto = new SpecificSearchToneDtoImpl();
        specificSearchToneDto.setSearchKey(searchKey); 
        specificSearchToneDto.setLanguage(TextTransform.checkSearchedLanguage(searchKey, 
            this.getContext().getUserContext().getLanguage()));
        specificSearchToneDto.setCategoryId("");
        specificSearchToneDto.setSortBy("Order_By");
        specificSearchToneDto.setAlignBy("ASC");
        specificSearchToneDto.setToneId(0);
        specificSearchToneDto.setPageNo(startIndex);
        specificSearchToneDto.setPagePerCount(offset);
        specificSearchToneDto.setSearchLanguage(TextTransform.checkSearchedLanguage(searchKey,
            this.getContext().getUserContext().getLanguage()));

        this.searchProcessor.getSpecificSearchTone()
        .success((specificSearchToneResponse: SpecificSearchToneResponse)=>
        {
            this.getAPIModelHandler().onSuccess(specificSearchToneResponse.getAPIFeature(), 
            specificSearchToneResponse.getDescription(), specificSearchToneResponse.getSpecificSearchToneDto());
           
         })
        .failure((specificSearchToneResponse: SpecificSearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(specificSearchToneResponse.getAPIFeature(), 
           specificSearchToneResponse.getDescription(), undefined);
         })
        .execute(new SpecificSearchToneRequestImpl(specificSearchToneDto));
        // this.getAPIModelHandler().onSuccess("", 
        // "", this.getListOfTones());
    }
   
    // private getListOfTones()
    // {  let tone1 = new ToneDtoImpl();
    //     tone1.setId("1");
    //     tone1.setToneName("1234rsva");
    //     tone1.setArtistName("987ytrfgbnmk");
    //     tone1.setImgPath("http://placehold.it/120x120&text=image1");
    //     tone1.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

    //     let tone2 = new ToneDtoImpl();
    //     tone2.setId("2");
    //     tone2.setToneName("1234rsva");
    //     tone2.setArtistName("987ytrfgbnmk");
    //     tone2.setImgPath("http://placehold.it/120x120&text=image2");
    //     tone2.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3");

    //     let tone3 = new ToneDtoImpl();
    //     tone3.setId("3");
    //     tone3.setToneName("1234rsva");
    //     tone3.setArtistName("987ytrfgbnmk");
    //     tone3.setImgPath("http://placehold.it/120x120&text=image3");
    //     tone3.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_5MG.mp3");

    //     let tone4 = new ToneDtoImpl();
    //     tone4.setId("4");
    //     tone4.setToneName("1234rsva");
    //     tone4.setArtistName("987ytrfgbnmk");
    //     tone4.setImgPath("http://placehold.it/120x120&text=image4");
    //     tone4.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

    //     let tone5 = new ToneDtoImpl();
    //     tone5.setId("5");
    //     tone5.setToneName("1234rsva");
    //     tone5.setArtistName("987ytrfgbnmk");
    //     tone5.setImgPath("http://placehold.it/120x120&text=image5");
    //     tone5.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

    //     let tone6 = new ToneDtoImpl();
    //     tone6.setId("6");
    //     tone6.setToneName("1234rsva");
    //     tone6.setArtistName("987ytrfgbnmk");
    //     tone6.setImgPath("http://placehold.it/120x120&text=image6");

    //     let tone7 = new ToneDtoImpl();
    //     tone7.setId("7");
    //     tone7.setToneName("1234rsva");
    //     tone7.setArtistName("987ytrfgbnmk");
    //     tone7.setImgPath("http://placehold.it/120x120&text=image7");

    //     let tone8 = new ToneDtoImpl();
    //     tone8.setId("8");
    //     tone8.setToneName("1234rsva");
    //     tone8.setArtistName("987ytrfgbnmk");
    //     tone8.setImgPath("http://placehold.it/120x120&text=image8");

    //     return [tone1, tone2, tone3, tone4, tone5, tone6, tone7, tone8];
    // }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/searchlistapimodel.ts